import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchQuickBoostById } from "./quickBoostService";
import "./QuickBoostDetailPage.css";

const QuickBoostDetailPage = () => {
 const { id } = useParams();
 const navigate = useNavigate();
 const [item, setItem] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 const load = async () => {
 setLoading(true);
 const res = await fetchQuickBoostById(id);
 if (res.status === 200 && res.data?.status) {
 setItem(res.data.data);
 }
 setLoading(false);
 };
 load();
 }, [id]);

 if (loading) {
 return (
 <>
 <Navbar />
 <div className="qbd-page">
 <p className="qbd-loading">Loading...</p>
 </div>
 <Footer />
 </>
 );
 }

 if (!item) {
 return (
 <>
 <Navbar />
 <div className="qbd-page">
 <p className="qbd-not-found">Quick boost not found.</p>
 <button
 className="qbd-back"
 onClick={() => navigate("/study/quick-boost")}
 >
 ← Back to Quick Boost
 </button>
 </div>
 <Footer />
 </>
 );
 }

 return (
 <>
 <Navbar />
 <div className="qbd-page">
 <button
 className="qbd-back"
 onClick={() => navigate("/study/quick-boost")}
 >
 ← Back to Quick Boost
 </button>

 <h1 className="qbd-title">{item.title}</h1>

 {/* Description */}
 <div className="qbd-card">
 <p className="qbd-description">{item.description}</p>
 </div>

 {/* YouTube Video */}
 {item.youtubeLink && (
 <div className="qbd-card">
 <h3 className="qbd-card-title">🎬 Watch Video</h3>
 <div className="qbd-video-wrapper">
 <iframe
 src={item.youtubeLink
 .replace("watch?v=", "embed/")
 .replace("youtu.be/", "youtube.com/embed/")}
 title={item.title}
 allowFullScreen
 frameBorder="0"
 />
 </div>
 </div>
 )}

 {/* Meta */}
 {item.createdAt && (
 <p className="qbd-meta">
 Added on{" "}
 {new Date(item.createdAt).toLocaleDateString("en-IN", {
 day: "numeric",
 month: "short",
 year: "numeric",
 })}
 </p>
 )}
 </div>
 <Footer />
 </>
 );
};

export default QuickBoostDetailPage;
